import abstract from './abstract'
import { Http } from 'sparnord-utils'
import sectionQuote from '@sections/quote'

export default class extends abstract {
  getComponent () {
    return sectionQuote
  }

  get layout () {
    return this.item.properties.quoteFormat || 'full'
  }

  get image () {
    let image

    try {
      image = this.item.properties.billedeAfCiteret || this.item.properties.citat.properties.billedeAfCiteret
    } catch (err) {
      image = null
    }

    image = image instanceof Array || !image ? null : image

    if (image) {
      image = this.getImageCropUrl(image)
    }

    return Http.Api.root + image.src + (image.crop || '')
  }

  getImageCropUrl (image) {
    if (image.crops) {
      let crops = [].concat(image.crops)
      let crop = crops.filter(c => c.alias.toLowerCase() === this.layout.toLowerCase()).shift()

      if (crop && crop.coordinates) {
        image.crop = `?crop=${Object.values(crop.coordinates).join(',')}&cropmode=percentage`
      }
    }

    return image
  }

  get quote () {
    let quote = this.item.properties.citat

    return typeof quote === 'string' ? quote : quote.properties.citat
  }

  get author () {
    try {
      return this.item.properties.citatAf || this.item.properties.citat.properties.citatAf
    } catch (err) {
      return null
    }
  }

  get position () {
    try {
      return this.item.properties.citeretPosition || this.item.properties.citat.properties.citeretPosition
    } catch (err) {
      return null
    }
  }

  get media () {
    let media = this.item.properties.citatMedia || this.item.properties.citat.properties.citatMedia
    return media instanceof Array || !media ? null : Http.Api.root + media
  }
}



// WEBPACK FOOTER //
// ./src/models/sections/quote.js